export enum SynopticCategory {
  CTA = 'cta',
  BOILER_ROOM = 'boilerRoom',
  HEAT_PUMP_CHILLER = 'heatPumpChiller',
}

export const MODULE_SYNOPTIC_CATEGORIES: ReadonlyArray<SynopticCategory> = [SynopticCategory.BOILER_ROOM, SynopticCategory.HEAT_PUMP_CHILLER]

export function isModuleSynopticCategory(category: SynopticCategory): boolean {
  return MODULE_SYNOPTIC_CATEGORIES.includes(category)
}
